var _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Rect, Path } from "react-native-svg";
function SvgCloseChat(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement(Rect, {
    width: 50,
    height: 50,
    fill: "#253144",
    fillOpacity: 0.75,
    rx: 16
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M31.548 19.88L19.806 31.623m11.741 0L19.806 19.881",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
export default SvgCloseChat;